export const environment = {
    production: true,
    hostname_port_be: 'https://tarifa.test.uoc.edu/back',
    hostname_port_fe: 'https://tarifa.test.uoc.edu',
    response_type: 'code',
    grant_type: 'authorization_code',
    redirect_uri: 'https://tarifa.test.uoc.edu/',
}